'use client';

import React from 'react';
import VietnamChart from '../vietnamChart';
import { jsonMaps } from '@/statics/data';

// Red River Delta (Đồng Bằng Sông Hồng)
// Northern Midlands and Uplands (Trung Du và Miền Núi Phía Bắc)
// Central Coastal Region (Duyên Hải Miền Trung)
// Central Highlands (Tây Nguyên)
// Southeast Region (Đông Nam Bộ)
// Mekong Delta (Đồng Bằng Sông Cửu Long)
// Northern Economic Region (Vùng Kinh Tế Trọng Điểm Phía Bắc)
// Central Economic Region (Vùng Kinh Tế Trọng Điểm Miền Trung)
// Southern Key Economic Region (Vùng Kinh Tế Trọng Điểm Phía Nam)
// Mekong Delta Economic Region (Vùng Kinh Tế Trọng Điểm ĐBSCL)
// Capital Region (Vùng Thủ Đô)
// 28 Coastal Provinces (28 Địa Phương Ven Biển)
// Vietnam

const titleMappingArea: Record<string, string> = {
  RDR: 'Đồng Bằng Sông Hồng',
  NMU: 'Trung Du và Miền Núi Phía Bắc',
  CCH: 'Duyên Hải Miền Trung',
  CHL: 'Tây Nguyên',
  SER: 'Đông Nam Bộ',
  MD: 'Đồng Bằng Sông Cửu Long',
  NER: 'Vùng Kinh Tế Trọng Điểm Phía Bắc',
  CER: 'Vùng Kinh Tế Trọng Điểm Miền Trung',
  SKER: 'Vùng Kinh Tế Trọng Điểm Phía Nam',
  MDE: 'Vùng Kinh Tế Trọng Điểm Đồng Bằng Sông Cửu Long',
  CR: 'Vùng Thủ Đô',
  CP28: '28 Địa Phương Ven Biển',
  VN: 'Việt Nam',
  SAE: '6 Vùng Kinh Tế',
  FAEK: '4 Vùng Kinh Tế Trọng Điểm',
};

export const slugMapping: Record<string, string> = {
  dong_bang_song_hong: 'RDR',
  trung_du_va_mien_nui_phia_bac: 'NMU',
  bac_trung_bo_va_duyen_hai_mien_trung: 'CCH',
  tay_nguyen: 'CHL',
  dong_nam_bo: 'SER',
  dong_bang_song_cuu_long: 'MD',
  vung_kinh_te_trong_diem_phia_bac: 'NER',
  vung_kinh_te_trong_diem_mien_trung: 'CER',
  vung_kinh_te_trong_diem_phia_nam: 'SKER',
  vung_kinh_te_trong_diem_dong_bang_song_cuu_long: 'MDE',
  vung_thu_do: 'CR',
  dia_phuong_ven_bien: 'CP28',
  ban_do_viet_nam: 'VN',
  sau_vung_kinh_te: 'SAE',
  bon_vung_kinh_te_trong_diem: 'FAEK',
};

export const slugMappingRelate: Record<string, string> = {
  dong_bang_song_hong: 'RDR',
  trung_du_va_mien_nui_phia_bac: 'NMU',
  bac_trung_bo_va_duyen_hai_mien_trung: 'CCH',
  tay_nguyen: 'CHL',
  dong_nam_bo: 'SER',
  dong_bang_song_cuu_long: 'MD',
  vung_kinh_te_trong_diem_phia_bac: 'NER',
  vung_kinh_te_trong_diem_mien_trung: 'CER',
  vung_kinh_te_trong_diem_phia_nam: 'SKER',
  vung_kinh_te_trong_diem_dong_bang_song_cuu_long: 'MDE',
  vung_thu_do: 'CR',
  dia_phuong_ven_bien: 'CP28',
  ban_do_viet_nam: 'VN',
  sau_vung_kinh_te: 'SAE',
  bon_vung_kinh_te_trong_diem: 'FAEK',
};

export const staticCustomKey = ['vn-hsi', 'vn-tsi', 'vn-dcd', 'vn-pqi'];

export type AreaVariant =
  | 'RDR'
  | 'NMU'
  | 'CCH'
  | 'CHL'
  | 'SER'
  | 'MD'
  | 'NER'
  | 'CER'
  | 'SKER'
  | 'MDE'
  | 'CR'
  | 'CP28'
  | 'VN'
  | 'VNN';

type IMapsDataType = {
  name: string;
  value: string | number | undefined;
  keyMapping: string;
  id: string;
};

interface MapsPackageProps {
  area: AreaVariant;
  dataMaps: IMapsDataType[];
  originalUrl: string | undefined;
  original: string | undefined;
  loading?: boolean;
  unit: string | undefined;
  mapTitle: string | undefined;
  timeData: string[];
  chartType?: string;
  id?: string;
  dataType?: string;
  isPageDetail?: boolean;
  onSelectTime: (value: string) => void;
}

const MapsPackage: React.FC<MapsPackageProps> = ({
  id,
  area,
  dataMaps,
  original,
  originalUrl,
  loading,
  unit,
  mapTitle,
  timeData,
  onSelectTime,
  chartType,
  dataType,
  isPageDetail = false,
}) => {
  return (
    <VietnamChart
      loading={loading}
      data={[...dataMaps] as any}
      mapDataVN={jsonMaps[chartType !== 'maps34' ? area : 'VNN']}
      title={titleMappingArea[area]}
      titleColorAxis={mapTitle}
      original={original}
      originalUrl={originalUrl}
      unit={unit}
      timeData={timeData}
      onSelectTime={onSelectTime}
      isCustom={!['VN', 'SAE', 'FAEK', 'V34'].includes(area)}
      dataType={dataType}
      chartType={chartType || 'VN'}
      isPageDetail={isPageDetail}
      id={id}
    />
  );
};

export default React.memo(MapsPackage);
